import CustomContactForm from "@/components/CustomContactForm";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface ContactFormModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function ContactFormModal({ open, onOpenChange }: ContactFormModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[700px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
            Get Started
          </DialogTitle>
          <DialogDescription>
            Tell us about your project and we'll get back to you within 24 hours with a custom proposal.
          </DialogDescription>
        </DialogHeader>
        
        <CustomContactForm onClose={() => onOpenChange(false)} />
      </DialogContent>
    </Dialog>
  );
}
